<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication" style="padding-top:130px;">
<p>“I came from an era when you had to be nice to men. I remember my mom saying that to me. She said, ‘You be a nice girl and if a man tells you to do this or that, you do it. OK?’ And let me tell you, that has its effect. It’s lasting. It took me a very, very, very long time to feel independent.”</p><br/>
<p style="text-align: right;">—Rita Moreno</p><br/>
<p style="text-indent: 0px;">Associated Press interview, published in the <em>San Francisco Chronicle</em>, February 25, 2019.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6996ff06